import { lazy } from 'react';

export const AuthRoutes = {
  Login: lazy(() => import('@/modules/Auth/pages/Login').then(({ Login }) => ({ default: Login }))),
  Logout: lazy(() =>
    import('@/modules/Auth/pages/Logout').then(({ Logout }) => ({ default: Logout })),
  ),
  MFASetup: lazy(() =>
    import('@/modules/Auth/pages/MFASetup').then(({ MFASetup }) => ({ default: MFASetup })),
  ),

  MobileAuth: lazy(() =>
    import('@/modules/Auth/pages/MobileAuth').then(({ MobileAuth }) => ({ default: MobileAuth })),
  ),

  RestorePassword: lazy(() =>
    import('@/modules/Auth/pages/RestorePassword').then(({ RestorePassword }) => ({
      default: RestorePassword,
    })),
  ),

  SiteSelect: lazy(() =>
    import('@/modules/Auth/pages/SelectSite').then(({ SelectSite }) => ({ default: SelectSite })),
  ),

  Terms: lazy(() =>
    import('@/modules/Auth/pages/Terms').then(({ Terms }) => ({
      default: Terms,
    })),
  ),

  TermsOfUse: lazy(() =>
    import('@/modules/Auth/pages/TermsOfUse').then(({ TermsOfUse }) => ({
      default: TermsOfUse,
    })),
  ),
};
